module.exports = __webpack_public_path__ + "img/egg.df7b0128.svg";